import React from 'react';

const STORE_URLS = {
  IOS: 'https://apps.apple.com/kr/app/%EB%96%A0%EB%A6%AC-%EB%B2%A0%EC%9D%B4%EC%BB%A4%EB%A6%AC-%EB%A7%88%EA%B0%90%ED%95%A0%EC%9D%B8/id6742439407?l=en-GB',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.thurry.thurry'
};

const Header: React.FC = () => {
  const detectDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isAndroid = /android/.test(userAgent);
    
    if (isIOS) return STORE_URLS.IOS;
    if (isAndroid) return STORE_URLS.ANDROID;
    return STORE_URLS.IOS; // 데스크톱의 경우 기본값으로 iOS 스토어
  };
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <img src="/images/ThurryLogo.png" alt="Thurry Logo" className="h-8 w-auto" />
          <img src="/images/ThurryText.png" alt="Thurry Text" className="h-6 w-auto" />
        </div>
        <div className="flex items-center space-x-2">
          <a 
            href="http://pf.kakao.com/_XFxoVn/chat"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 border-2 border-orange-500 text-orange-500 rounded-full text-sm font-medium hover:bg-orange-50 transition-colors"
          >
            입점문의
          </a>
          <button 
            onClick={() => window.open(detectDevice(), '_blank')}
            className="bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-orange-600 active:bg-orange-700 transform hover:scale-105 active:scale-95 transition-all shadow-md hover:shadow-lg"
          >
            앱다운로드
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;